import React from "react";
import { Flag, FlagNameValues } from "semantic-ui-react";

import { COUNTRY } from "../../../constants/country";
import NullComponent from "../../templates/NullComponent";

interface Props {
  flag?: FlagNameValues | COUNTRY;
}

const FlagLabel: React.FC<Props> = ({ flag, children }) => {
  if ((flag as unknown) === "gg") return <NullComponent />;
  if (flag) {
    return (
      <>
        <Flag name={flag} />
        {children}
      </>
    );
  }

  return <NullComponent />;
};

export default FlagLabel;
